import { render } from "./KoreanPancakeView.vue?vue&type=template&id=a74a403e"
import script from "./KoreanPancakeView.vue?vue&type=script&lang=js"
export * from "./KoreanPancakeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__